import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const handles = {
  [types.PAYRATES_GET_BY_ID_FULFILLED]: (state, payrate) => ({
    ...state,
    map: { ...state.map, [payrate._id]: payrate },
  }),
  [types.PAYRATES_GET_ALL_FULFILLED]: (state, payrates) => ({
    ...state,
    map: { ...state.map, ...keyBy(payrates, "_id") },
  }),
  [types.PAYRATES_GET_ASSOCIATION_FULFILLED]: (state, payrates) => ({
    ...state,
    map: { ...state.map, ...keyBy(payrates, "_id") },
  }),
  [types.PAYRATES_CREATE_ASSOCIATION_FULFILLED]: (state, payrate) => ({
    ...state,
    map: { ...state.map, [payrate._id]: payrate },
  }),
  [types.PAYRATES_UPDATE_ASSOCIATION_FULFILLED]: (state, payrate) => ({
    ...state,
    map: { ...state.map, [payrate._id]: payrate },
  }),
  [types.PAYRATES_DELETE_ASSOCIATION_FULFILLED]: (state, payrateId) => ({
    ...state,
    map: omit(state.map, payrateId),
  }),
  [types.PAYRATES_CLONE_FULFILLED]: (state, payrate) => ({
    ...state,
    map: { ...state.map, [payrate._id]: payrate },
  }),
};

export default function payratesReducer(state = intialState.payrates, action) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
